import React from 'react';
import { Button, Divider, Header, Form, Icon } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import RichTextEditor from '../../RichTextEditor';
import Metadata from '../Metadata';

const details = ({ obj, language, onChange }) => {
  return (
    <div>
      <Header as="h3">Bloc d'entête</Header>
      <Form.Field>
        <Form.Input
          label="Titre"
          placeholder="Titre de la page"
          id="title"
          value={obj.translations[language.code].title}
          onChange={(e) => onChange(e, language.code)}
        />
      </Form.Field>
      <Header as="h3">Bloc "Mot de la direction"</Header>
      <Form.Field>
        <Form.Input
          label="Titre"
          placeholder="Titre"
          id="block_word_title"
          value={obj.translations[language.code].block_word_title}
          onChange={(e) => onChange(e, language.code)}
        />
      </Form.Field>
      <Form.Field>
        <label>Contenu</label>
        <RichTextEditor
          id="block_word_content"
          value={obj.translations[language.code].block_word_content}
          onChange={(e) => onChange(e, language.code)}
        />
      </Form.Field>
      <Header as="h3">Bloc vidéo</Header>
      <Form.Field>
        <Form.Input
          label="Titre"
          placeholder="Titre de la page"
          id="block_video_title"
          value={obj.translations[language.code].block_video_title}
          onChange={(e) => onChange(e, language.code)}
        />
      </Form.Field>
      <Form.Field>
        <label>Contenu</label>
        <RichTextEditor
          id="block_video_content"
          value={obj.translations[language.code].block_video_content}
          onChange={(e) => onChange(e, language.code)}
        />
      </Form.Field>
      <Form.Group widths="equal">
        <Form.Input
          placeholder="Texte du bouton"
          id="block_video_cta_label"
          fluid
          label="Label du bouton"
          value={obj.translations[language.code].block_video_cta_label}
          onChange={(e) => onChange(e, language.code)}
        />
        <Form.Input
          placeholder="https://..."
          id="block_video_cta_url"
          fluid
          label="Adresse cible"
          value={obj.translations[language.code].block_video_cta_url}
          onChange={(e) => onChange(e, language.code)}
        />
      </Form.Group>
      <Header as="h3">Bloc push</Header>
      <Form.Field>
        <Form.Input
          label="Titre"
          placeholder="Titre"
          id="block_push_title"
          value={obj.translations[language.code].block_push_title}
          onChange={(e) => onChange(e, language.code)}
        />
      </Form.Field>
      <Form.Field>
        <label>Contenu</label>
        <RichTextEditor
          id="block_push_content"
          value={obj.translations[language.code].block_push_content}
          onChange={(e) => onChange(e, language.code)}
        />
      </Form.Field>
      <Form.Group widths="equal">
        <Form.Input
          placeholder="Texte du bouton"
          id="block_push_cta_label"
          fluid
          label="Label du bouton"
          value={obj.translations[language.code].block_push_cta_label}
          onChange={(e) => onChange(e, language.code)}
        />
        <Form.Input
          placeholder="https://..."
          id="block_push_cta_url"
          fluid
          label="Adresse cible"
          value={obj.translations[language.code].block_push_cta_url}
          onChange={(e) => onChange(e, language.code)}
        />
      </Form.Group>
      <Header as="h3">Bloc Instagram</Header>
      <Form.Field>
        <Form.Input
          label="Titre de la section"
          placeholder="Titre de la section"
          id="section_instagram_title"
          value={obj.translations[language.code].section_instagram_title || ''}
          onChange={(e) => onChange(e, language.code)}
        />
      </Form.Field>
      <Metadata obj={obj} language={language} onChange={onChange} />
      <Divider hidden={true} />
      <Button.Group fluid widths="2">
        <Link
          to="/the-place/content"
          floated="right"
          className="ui button olive"
        >
          <Icon name="chain" /> Slides de contenu
        </Link>
        <Link
          to="/the-place/project"
          floated="right"
          className="ui button olive"
        >
          <Icon name="chain" /> Slides "Le projet de réhabilitation"
        </Link>
      </Button.Group>
    </div>
  );
};

export default details;



// WEBPACK FOOTER //
// ./src/components/form/thePlace/details.js